import axiosInstance from "./axiosInstance";

// const authEndPoint = process.env.REACT_APP_STAGING_AUTH;
const gatewayEndPoint = process.env.REACT_APP_API_STAGING;

const postRequest = async(url, data) => {
    let requestOptions = {
        method : "POST",
        withCredentials : false,
        headers : {
            "Content-Type" : "application/json"
        },
        data
    }

    try {
        
        let res = await axiosInstance(gatewayEndPoint + url, requestOptions);

        if(res.status === 400 || res.status === 500){
        } else {
            // console.log(res.data)
            return res.data;
        }

    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        return error.response?.data ?? { err : error.message || "Network error" }
    }
}

const putRequest = async(url, data) => {
    let requestOptions = {
        method : "PUT",
        withCredentials : false,
        headers : {
            "Content-Type" : "application/json"
        },
        data
    }

    try {
        
        let res = await axiosInstance(gatewayEndPoint + url, requestOptions);

        if(res.status === 400 || res.status === 500){
        } else {
            // console.log(res.data)
            return res.data;
        }

    } catch (error) {
        // error.response is absent on network failures (server down, CORS, timeout)
        return error.response?.data ?? { err : error.message || "Network error" }
    }
}


export { 
    postRequest,
    putRequest
}